import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { SegmentType } from 'cio/models/segment';

// This is a very simplified version of the SegmentModel, to be used in places
// where we display a list of segments in a dropdown and don't actually need all
// the details.
// For example, the segment dropdowns in the dashboard segment usage card.
export default class ShortSegmentModel extends Model {
  @attr('string') type!: SegmentType;
  @attr('string') name!: string;
  @attr('boolean') hasRelationshipConditions?: boolean; // used to quickly detect segments with object relationships

  get isDynamic() {
    return this.type === 'dynamic';
  }

  get isManual() {
    return this.type === 'static';
  }

  get icon() {
    return this.type === 'static' ? 'segment-manual' : 'segment-data-driven';
  }
}
